import {useParams} from 'react-router-dom';

import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {BulletinForm} from 'src/app/bulletins/BulletinForm/BulletinForm';
import {UserGroupDocumentTitle} from 'src/app/user-groups/userGroupHelpers';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

export const EditBulletinPage = () => {
  useSetDocumentTitle(UserGroupDocumentTitle);
  const {id} = useParams();

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Bulletins}>
      {id !== undefined && <BulletinForm id={Number(id)} mode="edit" />}
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.BulletinEdit(':id', ':view'),
  element: <EditBulletinPage />,
  module: ModuleEnum.Bulletins,
  operation: PermissionOperationEnum.Update,
  isPrivate: true,
});

export default EditBulletinPage;
